document.addEventListener('DOMContentLoaded', () => {
  // Configuration object for URL conditions
  const headerClassConfig = {
    conditions: [
      '/pages/contact',
      '/cart',
      '/products/',
      '/collections/',
      '/store/'
      // Add more URL paths where you want to add the class
      // '/collections/sale',
      // '/blogs/news'
    ],
    
    // Method to check and apply classes
    applyHeaderClass() {
      const currentPath = window.location.pathname;
      
      if (this.conditions.some(condition => currentPath.includes(condition))) {
        const headerSection = document.querySelector('#shopify-section-sections--17742340227244__header');
        
        if (headerSection) {
          headerSection.classList.add('custom-black-header');
        }
      }
    }
  };

  // Execute the class application
  headerClassConfig.applyHeaderClass();
});